<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    bottom
    right
  >
    <v-row
      align="center"
      class="ma-0"
    >
      <v-icon class="mr-2">
        {{ icon }}
      </v-icon>
      {{ text }}
    </v-row>
    <template #action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="hideSnackbar"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'GeneralSnackbar',
  computed: {
    ...mapState('snackbar', {
      text: 'text',
      color: 'color',
      timeout: 'timeout'
    }),
    
    // Custom computed property with getter and setter for show
    show: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        if (!value) {
          this.hideSnackbar();
        } else {
          this.$store.commit('snackbar/setShow', value);
        }
      }
    },
    
    icon() {
      // Choose icon based on color
      switch(this.color) {
        case 'success':
          return 'mdi-check-circle-outline';
        case 'error':
          return 'mdi-alert-circle-outline';
        case 'warning':
          return 'mdi-alert-outline';
        case 'info':
          return 'mdi-information-outline';
        default:
          return 'mdi-bell-outline';
      }
    }
  },
  methods: {
    ...mapActions('snackbar', ['hideSnackbar'])
  }
};
</script>
